import React, { useCallback, useState } from "react";
import {
  getCurrentDayGames,
  getLastDigitOfANumber,
  gameIdentity,
  sumOfDigits,
  normalizeFatafat,
} from "../../util";
import deleteIcon from "./images/delete_red.png";
import { updateCollection } from "../../services/firebase";
import { FIREBASE_COLLECTION_DOC_KEY, FIREBASE_COLLECTION_KEY } from "../../constants";
import "./css/style.min.css";
import "./css/matkaplay.css";
import "../common.css";

const EditFatafatResultScreen = ({ data, fatafatTableList }) => {
  const sourceResults = data?.fatafatResults?.length
    ? data.fatafatResults
    : fatafatTableList || [];
  const [currentDayResults, setResults] = useState(
    getCurrentDayGames(sourceResults).map(normalizeFatafat)
  );

  const persistResults = (nextCurrentDay) => {
    const visibleIds = new Set(
      getCurrentDayGames(sourceResults).map((item) => gameIdentity(item))
    );
    const kept = sourceResults.filter(
      (item) => !visibleIds.has(gameIdentity(item))
    );
    updateCollection(FIREBASE_COLLECTION_KEY, FIREBASE_COLLECTION_DOC_KEY, {
      fatafatResults: [...kept, ...nextCurrentDay.map(normalizeFatafat)],
    })
      .then(() => {
        window.location.reload();
      })
      .catch((e) => {
        console.error("fatafat firebase save failed", e);
        alert("Could not save fatafat results in Firebase.");
      });
  };

  const handleOnChange = useCallback(
    (e, index) => {
      const { value } = e.target;
      const updatedResult = [...currentDayResults];
      updatedResult[index] = {
        ...updatedResult[index],
        guessNumber: value,
        resultValue: value,
        winnerValue: getLastDigitOfANumber(
          sumOfDigits(parseInt(value, 10))
        ).toString(),
      };
      setResults(updatedResult);
    },
    [currentDayResults]
  );

  const onDeleteResult = useCallback(
    (index) => {
      const next = [...currentDayResults];
      next.splice(index, 1);
      persistResults(next);
    },
    [currentDayResults, data, sourceResults]
  );

  const onSaveResult = useCallback(() => {
    persistResults(currentDayResults);
  }, [currentDayResults, data, sourceResults]);

  return (
    <>
      <div className="container round_border_card">
  <div className="d-flex align-items-center">
    <h2 className="white-header w-100">Edit/Delete Fatafat Results</h2>
    <div className="save-btn mr-2" onClick={onSaveResult}>
      Save
    </div>
  </div>
  <div>
    {currentDayResults.map((item, index) => {
      return (
        <div className="d-flex-custom" key={`${item.name}_${index}`}>
          <input
            id="startTime"
            name="startTime"
            className="form-control mb-2"
            required
            value={item.startTime}
            onChange={(e) => handleOnChange(e, index)}
          />
          <input
            type="number"
            id="guessNumber"
            name="guessNumber"
            className="form-control mb-2"
            maxLength={3}
            minLength={3}
            required
            value={item.guessNumber}
            onChange={(e) => handleOnChange(e, index)}
          />
          <img
            src={deleteIcon}
            title={`delete fatafatresult`}
            alt={`delete-fatafatresult`}
            onClick={() => onDeleteResult(index)}
          />
        </div>
      );
    })}
  </div>
</div>

    </>
  );
};

export default EditFatafatResultScreen;
